import React from 'react';
import BsModal from '../Common/BsModal';

const AlertChangeStatus = ({handleClose, title, description, show, onConfirm}) => {

    const confirm = async()=>{
        onConfirm();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title={title}
            footer={
                <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm
                    </button>
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>{description}</h5>
           
            </div>
          

        </BsModal>
    );
};

export default AlertChangeStatus;
